import React, {useEffect, useState} from "react";
import { message, Space, Button, Typography } from "antd";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import remarkGemoji from "remark-gemoji";
import { copyToClipboard } from "./utils/copy";

import {requestForm} from "./request"

const { Title } = Typography;
const defaultContent = `
# Hello, guys!, net is loading
wating...
`;

const MarkdownView = ({ markdownPath }) => {


  const [markdownContent, setMarkdownContent] = useState(defaultContent)

  useEffect(()=>{

    requestForm().get(`${markdownPath}.md`).then(result => setMarkdownContent(result.data));

  },[markdownPath])

  let index = 0;
  return (
    <>
      <div className="markdownContaner">
        <Markdown
          remarkPlugins={[remarkGfm, remarkGemoji]}
          rehypePlugins={[rehypeRaw]}
          components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || "");

              return !inline && match ? (
                <div className="codeBlock">
                  <Space.Compact block>
                    <Title
                      level={5}
                      style={{ margin: 0 }}
                    >
                      {match && match[1]}
                    </Title>
                    <Button
                      type="primary"
                      onClick={() => {
                        copyToClipboard(String(children));
                        setTimeout(() => {
                          message.success("复制成功");
                        }, 300);
                      }}
                    >
                      复制
                      {/* <CopyOutlined /> */}
                    </Button>
                  </Space.Compact>
                  <SyntaxHighlighter
                    {...props}
                    PreTag="div"
                    className="code_warp"
                    showLineNumbers={true}
                    language={match[1]}
                    style={vscDarkPlus}
                  >
                    {String(children).replace(/\n$/, "")}
                  </SyntaxHighlighter>
                </div>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
            table({ children }) {
              return (
                <div className="table_warp">
                  <table>
                  {children}
                  </table>
                </div>
              );
            },
            h1({ children }) {
              return (
                <h1
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h1>
              );
            },
            h2({ children }) {
              return (
                <h2
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h2>
              );
            },
            h3({ children }) {
              return (
                <h3
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h3>
              );
            },
            h4({ children }) {
              return (
                <h4
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h4>
              );
            },
            h5({ children }) {
              return (
                <h5
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h5>
              );
            },
            h6({ children }) {
              return (
                <h6
                  id={"heading-" + ++index}
                  className="heading"
                >
                  {children}
                </h6>
              );
            },

            a({ node, children, ...props }) {
              return (
                <a
                  {...props}
                  onClick={e => {
                    e.preventDefault();
                    copyToClipboard(props.href);
                    message.success("复制成功");
                  }}
                >
                  {children}
                </a>
              );
            },
          }}
        >
          {markdownContent}
        </Markdown>
      </div>
    </>
  );
};

export default MarkdownView;
